import React, { useEffect, useRef, useState } from "react"
import ProductService from "../../../shared/services/product"
import BenefitsProduct from "../benefits-product/benefits-product"
import BenefitsProductSpecial from "../benefits-product-special/benefits-product-special"
import HowUseProduct from "../how-use-product/how-use-product"
import CommentsProduct from "../comments-product/comments-product"
import DetailsProduct from "../details-product/details-product"
import StampProduct from "../stamp-product/stamp-product"
import StepsProduct from "../steps-product/steps-product"
import YouCanUseProduct from "../you-can-use-product/you-can-use-product"
import CardsDescriptionProduct from "../cards-description-product/cards-description-product"
import FrequentlyQuestions from "../frequently-questions/frequently-questions"
import YouTube from "react-youtube"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import "./product-section.scss"

const ProductSection = props => {
  const {
    patern,
    mobile,
    granPatern,
    title,
    params,
    paternTitle,
    setModalActive,
    isSecret,
  } = props

  const [currentPageComment, setCurrentPageComment] = useState(0)
  const [isLastPage, setisLastPage] = useState(false)
  const [SummaryResponse, setsummaryResponse] = useState(null)
  const [initLoad, setinitLoad] = useState(true)
  const [stepsList, setStepsList] = useState([]);
  const [stepVideo, setStepVideo] = useState(null);
  const isToallaReu = params.codigoDeProducto.includes("TREU")


  var numberItems = 3

  useEffect(() => {
    var currentPageCommentCopy = currentPageComment
    handleLoadSummary()
    setinitLoad(false)
    setCurrentPageComment(currentPageCommentCopy + 1)
  }, [])
  useEffect(()=>{
    if(params?.pasoAPaso?.length){
      const obj = {...params.pasoAPaso[0]};
      setStepVideo(obj.video ? obj : null);
      
      let aux = [];
      params.pasoAPaso.map((step) => {
        if(!step.video){
          aux = [...aux, {...step}];
        }
      })
      setStepsList(aux);
    }
  }, [])

  const handleLoadSummary = () => {
    if (initLoad) {
      ProductService.summaryProducts(
        params.codigoDeProducto,
        numberItems,
        currentPageComment
      )
        .then(res => {
          setsummaryResponse(res.data)
          if (res.metadata?.limit === res.metadata?.currentPage + 1) {
            setisLastPage(true)
          }
        })
        .catch(e => console.log(e))

      //In next load, load any items
    } else {
      var currentPageCommentCopy = currentPageComment
      var copyCommentsList = SummaryResponse

      ProductService.summaryProducts(
        params.codigoDeProducto,
        numberItems,
        currentPageComment
      )
        .then(res => {
          copyCommentsList.opinions = copyCommentsList.opinions.concat(
            res.data.opinions
          )
          setsummaryResponse(copyCommentsList)
          setCurrentPageComment(currentPageCommentCopy + 1)
          if (res.metadata.limit === res.metadata.currentPage + 1) {
            setisLastPage(true)
          }
        })
        .catch(e => console.log(e))
    }
  }

  const haveShopSecret = !(
    ["es-BO"].includes(process.env.LOCALE) &&
    params.codigoDeProducto.includes("SECRET")
  )

  return (
    <section className="f-product-section-container">
      <DetailsProduct
        isSecret={isSecret}
        setModalActive={setModalActive}
        subCategory={patern}
        params={params}
        mobile={mobile}
        title={title}
        paternTitle={paternTitle}
        granPatern={granPatern}
        patern={patern}
        numberOfRatings={SummaryResponse && SummaryResponse.numberOfRatings}
        averageScore={SummaryResponse && SummaryResponse.averageScore}
        haveShopSecret={haveShopSecret}
      />

      {isSecret && (
        <CardsDescriptionProduct
          stamps={params.sellos}
          mobile={mobile}
          code={params.codigoDeProducto}
          haveShopSecret={haveShopSecret}
          flujoType={params.flujo}
        />
      )}

      {!isSecret && <StampProduct stamps={params.sellos} />}

      { 
        stepsList.length > 0 &&
       <StepsProduct
          steps={stepsList}
          mobile={mobile}
          setModalActive={setModalActive}
        />
      }

      {
        stepVideo &&
        <div className="f-steps-container-video">
            {isToallaReu ?
              <>
                <TitleTab className={"f-TitleTab f-TitleTab-pink"}
                  title="Aprende cómo usarla" />
                  <p className="f-TitleTab__black">Ubica la toalla sobre tu ropa interior, dobla las alas abrazándola y presiona el botón para fijar la toalla.</p>
              </>
              :null}
          <YouTube
            containerClassName="f-steps-video"
            videoId={
              params.pasoAPaso[0].video.split("/")[params.pasoAPaso[0].video.split("/").length - 1]
            }
          />
        </div>
      }

      {isSecret && !isToallaReu && (
        <BenefitsProductSpecial
          mobile={mobile}
          code={params.codigoDeProducto}
          haveShopSecret={haveShopSecret}
          flujoType={params.flujo}
        />
      )}

      {!isSecret && <BenefitsProduct params={params} mobile={mobile} />}

      {isSecret && (
        <>
          <HowUseProduct params={params} mobile={mobile} flujoType={params.flujo} code={params.codigoDeProducto}/>
          <FrequentlyQuestions params={params} mobile={mobile} />
        </>
      )}

      <YouCanUseProduct params={params} />

      <CommentsProduct
        setModalActive={setModalActive}
        setisLastPage={setisLastPage}
        isLastPage={isLastPage}
        idProduct={params.codigoDeProducto}
        setsummaryResponse={setsummaryResponse}
        handleLoadSummary={handleLoadSummary}
        summaryResponse={SummaryResponse}
        productName={params.titulo}
      />
    </section>
  )
}

export default ProductSection
